"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var colour_1 = require("../theme/colour");
var size_1 = require("../theme/size");
function DownloadIcon(_a) {
    var _b = _a.colour, colour = _b === void 0 ? colour_1.colours.purple[60] : _b, _c = _a.size, size = _c === void 0 ? size_1.IconSize.NORMAL : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 12 12" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M10 8V10H2V8H0.666664V10C0.666664 10.7333 1.26666 11.3333 2 11.3333H10C10.7333 11.3333 11.3333 10.7333 11.3333 10V8H10ZM9.33333 5.33334L8.39333 4.39334L6.66666 6.11334V0.666672H5.33333V6.11334L3.60666 4.39334L2.66666 5.33334L6 8.66667L9.33333 5.33334Z", fill: colour }) })));
}
exports.DownloadIcon = DownloadIcon;
